<template>
  <div>
    <h3>Backup</h3>
    <div class="row">

      <div class="col" v-if="backups.length > 0">
        <select class="form-select" v-model="selectedDate" @change="filterBackups">
          <option value="">Все даты</option>
          <option v-for="date in uniqueDates" :key="date" :value="date">
            {{ date }}
          </option>
        </select>
      </div>

      <div class="col-auto">
        <div class="d-flex">
          <BackupSettingCreate class="me-2"/>
          <BackupRun v-if="backupSettings.length > 0" />
        </div>
      </div>
    </div>
    <br>

    <div v-if="groupedBackups.length > 0">
      <div v-for="group in groupedBackups" :key="group.id">
        <button type="button" class="btn btn-link ps-0 text-dark" @click="openModal(group.settingId)">
          <b>{{ getBackupSettingName(group.settingId) }}</b>
        </button>

        <table class="table table-striped table-sm">
          <thead>
          <tr>
            <th scope="col">Время</th>
            <th scope="col">Статус</th>
            <th scope="col">Шаг</th>
            <th scope="col">Объем</th>
            <th scope="col">Ссылка</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="backup in group.backups" :key="backup.id">
            <td>{{formatDateTime(backup.backupAt)}}</td>
            <td>{{backup.status}}</td>
            <td>{{backup.step}}</td>
            <td>{{(backup.volume) ? formatSize(backup.volume) : ''}}</td>
            <td><a href="#" v-if="backup.status === 'success'"  @click="handleDownload(backup.id)">Скачать</a></td>
          </tr>
          </tbody>
        </table>
      </div>

      <BackupSettingUpload
          v-model="showModal"
          :settingId="currentSettingId"
          :backupSetting="currentBackupSetting"
      />

    </div>
  </div>
</template>

<script setup>
import {useBackupStore} from "@/store/backups";
import {computed, defineProps, ref, watch} from "vue";
import {useBackupSettingStore} from "@/store/backup-settings";
import BackupSettingCreate from "@/components/backups/BackupSettingCreate";
import BackupRun from "@/components/backups/BackupRun";
import {useNotificationsStore} from "@/store/notifications";
import BackupSettingUpload from "@/components/backups/BackupSettingUpload.vue";

const props  = defineProps({
  serviceId: Number,
})

const showModal = ref(false)
const currentSettingId = ref(null)
const currentBackupSetting = ref(null)

// Настройку ищем по номеру, а не по порядку группы: раньше форма открывала данные
// другой настройки и при сохранении записывала их в выбранную
const openModal = (settingId) => {
  currentSettingId.value = settingId
  currentBackupSetting.value = backupSettings.value.find(s => s.id === settingId) ?? null
  showModal.value = currentBackupSetting.value != null
}

const backupSettingStore = useBackupSettingStore()
const backupSettings = computed(() => backupSettingStore.items)
const loadBackupSettings = async () => {
  try {
    await backupSettingStore.getList({serviceId: props.serviceId})
    console.log('Настройки загружены:', backupSettings.value)
  } catch (error) {
    console.error('Ошибка загрузки настроек:', error)
  }
}

loadBackupSettings() // вызов функции

const backupStore = useBackupStore()
const backups = computed(() => backupStore.items)
backupStore.getList({serviceId: props.serviceId})

const selectedDate = ref('')

const formatDateTime = (isoString) => new Date(isoString).toLocaleString('ru-RU');
const formatDate = (isoString) => new Date(isoString).toLocaleDateString('ru-RU');

const formatSize = (bytes) => {
  if (bytes === 0) return '0 Bytes'
  const k = 1024
  const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB']
  const i = Math.floor(Math.log(bytes) / Math.log(k))
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i]
}

const getBackupSettingName = (id) => {
  const setting = backupSettings.value.find(s => s.id === id)
  // без названия кнопка была пустой и невидимой — настройку нельзя было открыть
  return setting?.name || `Настройка #${id} (без названия)`
}

const uniqueDates = computed(() => {
  return [...new Set(backups.value.map(b => formatDate(b.backupAt)))].sort().reverse()
})

const groupedBackups = computed(() => {
  const filtered = selectedDate.value
      ? backups.value.filter(b => formatDate(b.backupAt) === selectedDate.value)
      : backups.value

  const groups = {}
  filtered.forEach(backup => {
    const settingId = backup.backupSettingId
    if (!groups[settingId]) {
      groups[settingId] = {
        settingId,
        backups: []
      }
    }
    groups[settingId].backups.push(backup)
  })

  return Object.values(groups)
})


const handleDownload = (backupId) => {
  backupStore.download(backupId);
};

// обновление данных
const notificationsStore = useNotificationsStore()
// обновление бэкапов
const backupLog = computed(() => notificationsStore.debug['backups'])
notificationsStore.onDebug('backups')
watch(() => backupLog.value, async () => {
  if(backupLog.value.data.serviceId === props.serviceId) {
    await backupStore.getList({serviceId: props.serviceId})

  }
})

</script>
